export default __webpack_public_path__ + "static/media/img_post2_2.b50da101.png";